import React, { FC } from "react";
import styles from "./SpotlightrGallery.module.css";
import {
	IUserTrainingCourseSectionSummary,
	IUserTrainingCourseSummary,
	IUserTrainingCourseVideoSummary,
	TrainingGallerySectionType,
} from "src/@types/ImpiricaPlatformApi";
import { SpotlightrGalleryHtmlSection } from "./SpotlightrGalleryHtmlSection";
import { SpotlightrGalleryVideoSection } from "./SpotlightrGalleryVideoSection";

type SpotlightrGalleryProps = {
	course: IUserTrainingCourseSummary;
	onLaunchVideo?: (video: IUserTrainingCourseVideoSummary) => void;
};

export const SpotlightrGallery: FC<SpotlightrGalleryProps> = ({
	course,
	onLaunchVideo,
}) => {
	const renderSection = (section: IUserTrainingCourseSectionSummary) => {
		switch (section.type) {
			case TrainingGallerySectionType.Html:
				return <SpotlightrGalleryHtmlSection section={section} />;
			case TrainingGallerySectionType.Video:
				return (
					<SpotlightrGalleryVideoSection
						section={section}
						onLaunchVideo={onLaunchVideo}
					/>
				);
			default:
				return <div>{section.name}</div>;
		}
	};

	return (
		<div className={styles.spotlightrGallery} data-testid="spotlightr-gallery">
			<div>
				<h1>{course.title}</h1>

				<div>
					{course.sections &&
						course.sections.map((section, index) => (
							<div
								className={styles.section}
								id={section.name ? encodeURI(section.name) : ""}
								key={index}
							>
								{renderSection(section)}
							</div>
						))}
				</div>
			</div>
		</div>
	);
};
